module.exports = __webpack_public_path__ + "img/slolution-2.ff6de26.png";